import { lazy } from "react";

const Login = lazy(() => {
  return import.meta.env.VITE_MODE === "admin"
    ? import("./Login.admin")
    : import("./Login");
});

export default Login;
